import styled from 'styled-components';

export const GroupHeader = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
`;

export const GroupDetails = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px;
`;

export const AdminName = styled.div`
  display: flex;
  font-size: 13px;
`;

export const GroupName = styled.div`
  display: flex;
`;

export const EditGroup = styled.div`
  display: flex;
`;
